// PCとSPを切り替えるブレイクポイント
export const breakpoint = 900;
export const containerID = 'c-pics';
export const assets_path = '/manage/wp-content/themes/pics/assets/';